import React, { useState, useEffect } from "react";
import Edit from "../../Assets/img/Edit.svg";
import Delet from "../../Assets/img/Delete.svg";
import defaultImg from "../../Assets/img/default-image.png";
import "../Services/Services.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";
import OurServicesFullPreview from "./OurServicesFullPreview";
const OurServices = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(true);
    const [deleteId, setDeleteId] = useState(null);

    const [mainData, setMainData] = useState({ heading: "", title: "" });
    const [showEditPopup, setShowEditPopup] = useState(false);

    const [editForm, setEditForm] = useState({ heading: "", title: "" });
    const [listItems, setListItems] = useState([]);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const lang = queryParams.get("lang");
    const [languageId, setLanguageId] = useState(lang ? Number(lang) : 1);
    const [showPreviewOurServiceFull, setShowPreviewOurServiceFull] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const serviceMap = { 1: 5, 2: 10 };

    const ourserviceIdMap = { 1: 1, 2: 2 };
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });
    const fetchOurService = () => {
        setLoading(true);
        const newId = ourserviceIdMap[languageId];

        API.post("ourserviceListView/condition", {
            ourservice_id: newId,
            language_id: languageId,
            service_id: serviceMap[languageId]
        })
            .then((res) => {
                const data = res.data?.data;
                if (data) {
                    setMainData({
                        heading: data.ourservice?.heading || "",
                        title: data.ourservice?.title || "",
                    });

                  const filtered = (data.listitems || [])
  .filter((item) => item.active !== 4)
  .sort((a, b) => a.order_by - b.order_by);
                    setListItems(filtered);
                }
            })
            .catch((err) => console.error("❌ Fetch failed:", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchOurService();
    }, [languageId]);

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        API.post("listofservice_status/update", {
            listofservice_id: id,
            status: newStatus,
        })
            .then(() => fetchOurService())
            .catch((err) => console.error("Failed to update status:", err));
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };

    const confirmDelete = () => {
        if (!deleteId) return;

        API.post("listofservice_delete/update", {
            listofservice_id: deleteId,
            active: 4,
        })
            .then((res) => {
                setShowPopup(false);
                setDeleteId(null);

                if (res.data?.success) {
                    setPopup({
                        show: true,
                        title: "Deleted",
                        message: "Service deleted successfully!",
                        type: "success"
                    });
                } else {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "Failed to delete service.",
                        type: "error",
                    });
                }

                fetchOurService();
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Something went wrong while deleting.",
                    type: "error",
                })
            );
    };


    const handleMainUpdate = () => {

        if (!editForm.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required!",
                type: "info",
            });
        }

        if (!editForm.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required!",
                type: "info",
            });
        }

        const newId = ourserviceIdMap[languageId];

        const payload = {
            service_id: serviceMap[languageId],
            ourservice_id: newId,
            language_id: languageId,
            heading: editForm.heading,
            title: editForm.title,
            status: "active",
            active: 1,
        };

        API.post("ourservice_edit/update", payload)
            .then((res) => {
                if (res.data?.success) {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: "Updated successfully!",
                        type: "success",
                    });

                    setMainData({
                        heading: editForm.heading,
                        title: editForm.title
                    });

                    setShowEditPopup(false);
                } else {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: res.data?.message || "Update failed!",
                        type: "error",
                    });
                }
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Something went wrong. Please try again.",
                    type: "error",
                })
            );
    };

    const handlePreview = () => {
        if (!mainData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required for preview",
                type: "info",
            });
        }

        if (!mainData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required for preview",
                type: "info",
            });
        }

        if (!listItems.length) {
            return setPopup({
                show: true,
                title: "Required",
                message: "At least one service is required for preview",
                type: "info",
            });
        }

        setPreviewData({
            ourservice: {
                heading: mainData.heading,
                title: mainData.title,
            },
            listitems: listItems.map(item => ({
                ...item,
                image: item.image || defaultImg
            }))
        });

        setShowPreviewOurServiceFull(true);
    };



    return (
        <div className="category-container1">
            <div className="category-header1">
                <h2 className="category-title1">Our Services</h2>

                <div className="header-buttons">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                onChange={(e) => {
                                    const newLang = Number(e.target.value);
                                    const newOurServiceId = ourserviceIdMap[newLang];
                                    setLanguageId(newLang);
                                    navigate(`/ourservices/${newOurServiceId}?lang=${newLang}`);
                                }}
                                value={languageId}
                                className="input-field"
                            >
                                <option value="1">English</option>
                                <option value="2">Français</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button
                        className="language-save-btn"
                        onClick={() => {
                            setEditForm({
                                heading: mainData.heading,
                                title: mainData.title,
                            });
                            setShowEditPopup(true);
                        }}
                    >
                        Edit Our Services
                    </button>

                    <button
                        className="language-cancel-btn"
                        onClick={() => navigate("/services")}
                    >
                        Back
                    </button>
                </div>
            </div>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="our-services-form-card">
                        <form>
                            <div className="cate-form-row">
                                <div className="cate-form-field">
                                    <label>
                                        Heading <span className="required">*</span>
                                    </label>
                                    <input type="text" value={mainData.heading} disabled />
                                </div>
                            </div>
                            <div className="cate-form-field">
                                <label>Title</label>
                                <input type="text" value={mainData.title} disabled />
                            </div>
                        </form>
                    </div>

                    <div style={{ marginTop: "10px" }}>
                        <div className="category-header1">
                            <h2 className="category-title1">List Services</h2>
                            <div className="header-buttons">
                                <button
                                    className="btn saves-btn"
                                    onClick={() => navigate(`/servicesadd/${id}?lang=${languageId}`)}
                                >
                                    Add Services
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="newss-grid">
                        {listItems.length === 0 ? (
                            <p>No services found.</p>
                        ) : (
                            listItems.map((item) => (
                                <div className="our-services-card" key={item.listofservice_id}>
                                    <div>
                                        <img
                                            src={item.image || defaultImg}
                                            alt="Service"
                                            className="service-blog-image"
                                        />
                                    </div>

                                    <p>{item.heading}</p>

                                    <div className="category-card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(item.listofservice_id, item.status)
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() =>
                                                    navigate(`/servicesedit/${item.listofservice_id}`, {
                                                        state: { service: item },
                                                    })
                                                }
                                            />

                                            <img
                                                src={Delet}
                                                alt="Delete"
                                                className="icon-btn1"
                                                onClick={() => handleDeleteClick(item.listofservice_id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}

                        {showEditPopup && (
                            <div className="blogtag-popup-overlay">
                                <div className="blogtag-popup-box edit-mode">
                                    <h3>Edit Our Services</h3>

                                    <div className="blogtag-admin-form-group">
                                        <label>Heading</label>
                                        <input
                                            type="text"
                                            value={editForm.heading}
                                            onChange={(e) =>
                                                setEditForm({ ...editForm, heading: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="blogtag-admin-form-group">
                                        <label>Title</label>
                                        <input
                                            type="text"
                                            value={editForm.title}
                                            onChange={(e) =>
                                                setEditForm({ ...editForm, title: e.target.value })
                                            }
                                        />
                                    </div>

                                    <div className="blogtag-popup-buttons">
                                        <button
                                            className="cancel-btn "
                                            onClick={() => setShowEditPopup(false)}
                                        >
                                            Back
                                        </button>

                                        <button className="btn saves-btn" onClick={handleMainUpdate}>
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* DELETE POPUP */}
                        {showPopup && (
                            <div className="popup-overlay">
                                <div className="popup-box">
                                    <h3>Confirm Delete</h3>
                                    <p>Are you sure you want to delete this service?</p>

                                    <div className="popup-buttons">
                                        <button
                                            className="cancel-btn "
                                            onClick={() => setShowPopup(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button className="btn delete-btn" onClick={confirmDelete}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                             <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/services");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showPreviewOurServiceFull && (
                <OurServicesFullPreview
                    previewService={previewData}
                    setShowPreviewOurServiceFull={setShowPreviewOurServiceFull}
                />
            )}
        </div>
    );
};

export default OurServices;
